<template>
  <v-dialog
    persistent
    v-model="generateSpecialCnModal"
    transition="dialog-bottom-transition"
    max-width="640"
    content-class="cn-dialog"
  >
    <div class="cn-modal">
      <!-- Header -->
      <div class="cn-modal__header">
        <div class="cn-modal__header-left">
          <div class="cn-modal__icon">
            <v-icon color="var(--app-accent)" size="22">mdi-receipt-text-plus-outline</v-icon>
          </div>
          <div>
            <div class="cn-modal__title">Generate Special CN Case</div>
            <div class="cn-modal__subtitle">Configure credit note details below</div>
          </div>
        </div>
        <button class="cn-modal__close" @click="toggleGenerateSpecialCnModal(false)">
          <v-icon size="20" color="var(--app-text-faint)">mdi-close</v-icon>
        </button>
      </div>

      <!-- Body -->
      <div class="cn-modal__body">
        <!-- Available HRDC Inv No -->
        <div class="cn-info-badge">
          <v-icon size="14" color="#0369a1" class="mr-1">mdi-information-outline</v-icon>
          Available HRDC Inv No.: <strong>{{ formData.hrdcInvoiceNo }}</strong>
        </div>

        <!-- CN Pax -->
        <div class="cn-form-row">
          <label class="cn-form-label">CN Pax <span class="cn-required">*</span></label>
          <div class="cn-form-field">
            <v-text-field
              ref="specialCnPax"
              type="number"
              dense
              filled
              placeholder="Enter number of CN (max 3)"
              v-model="formData.specialCnPax"
              :error-messages="errorField.specialCnPax"
              @input="onInputDigits(null, 'specialCnPax')"
              class="cn-input"
              hide-details="auto"
            ></v-text-field>
          </div>
        </div>

        <!-- Dynamic CN Rows -->
        <div
          v-for="(pax, index) in Array.from(
            { length: Number(formData.specialCnPax) },
            (_, i) => i + 1
          )"
          :key="index"
          class="cn-pax-card"
        >
          <div class="cn-pax-card__badge">CN {{ pax }}</div>

          <!-- Client INV No. -->
          <div class="cn-form-row">
            <label class="cn-form-label">Client Inv No. <span class="cn-required">*</span></label>
            <div class="cn-form-field">
              <v-text-field
                ref="clientInvNo"
                dense
                filled
                placeholder="YGC-XXXXXX"
                :error-messages="errorField.clientInvNo[index]"
                class="cn-input"
                hide-details="auto"
              ></v-text-field>
            </div>
          </div>

          <!-- HRDC INV No. -->
          <div class="cn-form-row">
            <label class="cn-form-label">HRDC Inv No. <span class="cn-required">*</span></label>
            <div class="cn-form-field">
              <v-text-field
                ref="hrdcInvNo"
                dense
                filled
                placeholder="YGC-XXXXXX"
                :error-messages="errorField.hrdcInvNo[index]"
                class="cn-input"
                hide-details="auto"
              ></v-text-field>
            </div>
          </div>

          <!-- CN Amount -->
          <div class="cn-form-row">
            <label class="cn-form-label">CN Amount <span class="cn-required">*</span></label>
            <div class="cn-form-field">
              <v-text-field
                ref="cnAmount"
                type="number"
                dense
                filled
                placeholder="2888, 2388, ..."
                :error-messages="errorField.cnAmount[index]"
                @input="onInputDigits(index, 'cnAmount')"
                class="cn-input"
                hide-details="auto"
              ></v-text-field>
            </div>
          </div>

          <!-- CN Description -->
          <div class="cn-form-row">
            <label class="cn-form-label">CN Description <span class="cn-required">*</span></label>
            <div class="cn-form-field">
              <v-textarea
                ref="cnDesc"
                dense
                filled
                auto-grow
                :error-messages="errorField.cnDesc[index]"
                :placeholder="cnDescPlaceholder"
                class="cn-input"
                hide-details="auto"
              ></v-textarea>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="cn-modal__footer">
        <button
          class="cn-modal__btn cn-modal__btn--cancel"
          @click="toggleGenerateSpecialCnModal(false)"
        >
          Discard
        </button>
        <button
          class="cn-modal__btn cn-modal__btn--confirm"
          @click="saveGenerateSpecialCnInfoChild()"
        >
          Confirm
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "GenerateSpecialCn",
  props: {
    generateSpecialCnModal: Boolean,
    formData: Object,
    errorField: Object,
  },
  emits: ["toggleGenerateSpecialCnModal"],
  data: () => ({
    cnDescPlaceholder: `TaxPOD Masterclass 1-year pass to all trainings and webinars from <Start Date> to <End Date>\n- Stripe Ref: in_XXXXXX`,
  }),
  methods: {
    toggleGenerateSpecialCnModal(val) {
      this.$emit("toggleGenerateSpecialCnModal", val);
    },
    onInputDigits(index = null, field) {
      let input = null;
      if (index || index == 0) {
        input = this.$refs[field][index];
      } else {
        input = this.$refs[field];
      }

      input.$el.querySelector("input").value = input.$el
        .querySelector("input")
        .value.replace(/[^0-9]/g, "");
    },
    saveGenerateSpecialCnInfoChild() {
      this.$emit("saveGenerateSpecialCnInfoChild", this.$refs);
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .cn-modal {
  background: var(--app-card);
}

.dark-mode .cn-modal__header {
  border-bottom: 1px solid var(--app-border);
}

.dark-mode .cn-modal__icon {
  background: var(--app-accent-soft);
}

.dark-mode .cn-modal__title {
  color: var(--app-text);
}

.dark-mode .cn-modal__subtitle {
  color: var(--app-text-faint);
}

.dark-mode .cn-modal__close {
  border: 1px solid var(--app-border);
  background: var(--app-card);
}

.dark-mode .cn-modal__close:hover {
  background: var(--app-surface);
  border-color: var(--app-border-strong);
}

.dark-mode .cn-info-badge {
  background: var(--app-accent-soft);
}

.dark-mode .cn-input >>> .v-input__slot {
  background: var(--app-card) !important;
  border: 1px solid var(--app-border) !important;
}

.dark-mode .cn-input >>> .v-text-field__slot input::placeholder,
.dark-mode .cn-input >>> .v-text-field__slot textarea::placeholder {
  color: var(--app-text-faint) !important;
}

.dark-mode .cn-pax-card {
  background: var(--app-surface);
  border: 1px solid var(--app-border);
}

.dark-mode .cn-pax-card .cn-input >>> .v-input__slot {
  background: var(--app-card) !important;
}

.dark-mode .cn-modal__footer {
  border-top: 1px solid var(--app-border);
}

.dark-mode .cn-modal__btn--cancel {
  background: var(--app-card);
  color: var(--app-text-muted);
  border: 1.5px solid var(--app-border-strong);
}

.dark-mode .cn-modal__btn--cancel:hover {
  background: var(--app-surface);
  border-color: var(--app-border-strong);
}

/* >>> end auto-dark <<< */

/* ============================================
   DIALOG
   ============================================ */
.cn-modal {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* ============================================
   HEADER
   ============================================ */
.cn-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 28px 18px;
  border-bottom: 1px solid #f1f5f9;
}

.cn-modal__header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.cn-modal__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #e0f2fe;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cn-modal__title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1e293b;
}

.cn-modal__subtitle {
  font-size: 0.78rem;
  color: #94a3b8;
  margin-top: 1px;
}

.cn-modal__close {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.cn-modal__close:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

/* ============================================
   BODY
   ============================================ */
.cn-modal__body {
  padding: 22px 28px;
  max-height: 60vh;
  overflow-y: auto;
}

.cn-info-badge {
  display: inline-flex;
  align-items: center;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 8px 14px;
  border-radius: 10px;
  margin-bottom: 20px;
}

/* ============================================
   FORM ROWS
   ============================================ */
.cn-form-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 14px;
  gap: 12px;
}

.cn-form-label {
  flex: 0 0 130px;
  font-size: 0.8rem;
  font-weight: 700;
  color: #2d3239;
  line-height: 1.6;
  padding-top: 8px;
}

.cn-required {
  color: #ef4444;
}

.cn-form-field {
  flex: 1;
  min-width: 0;
}

/* Input styling */
.cn-input >>> .v-input__slot {
  background: #fff !important;
  border: 1px solid #e2e4e8 !important;
  border-radius: 8px !important;
  min-height: 40px !important;
  transition: all 0.15s ease;
}

.cn-input >>> .v-input__slot:hover {
  border-color: #c9cdd3 !important;
}

.cn-input.v-input--is-focused >>> .v-input__slot {
  border-color: #0ea5e9 !important;
}

.cn-input >>> .v-input__slot::before,
.cn-input >>> .v-input__slot::after {
  display: none !important;
}

.cn-input >>> .v-text-field__slot input,
.cn-input >>> .v-text-field__slot textarea {
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1a1e24;
}

.cn-input >>> .v-text-field__slot input::placeholder,
.cn-input >>> .v-text-field__slot textarea::placeholder {
  color: #94a3b8 !important;
  font-weight: 500;
}

/* Error state */
.cn-input.v-input--has-state >>> .v-input__slot {
  border-color: #ef4444 !important;
}

/* ============================================
   PAX CARDS
   ============================================ */
.cn-pax-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 18px;
  margin-bottom: 16px;
}

.cn-pax-card:last-child {
  margin-bottom: 0;
}

.cn-pax-card__badge {
  display: inline-block;
  background: linear-gradient(135deg, #10b981, #34d399);
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 4px 12px;
  border-radius: 8px;
  margin-bottom: 16px;
  text-transform: uppercase;
}

.cn-pax-card .cn-input >>> .v-input__slot {
  background: #fff !important;
}

/* ============================================
   FOOTER
   ============================================ */
.cn-modal__footer {
  display: flex;
  gap: 12px;
  padding: 18px 28px 24px;
  border-top: 1px solid #f1f5f9;
}

.cn-modal__btn {
  flex: 1;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}

.cn-modal__btn--cancel {
  background: #fff;
  color: #64748b;
  border: 1.5px solid #d1d5db;
}

.cn-modal__btn--cancel:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.cn-modal__btn--confirm {
  background: #56bde8;
  color: #fff;
  border: none;
}

.cn-modal__btn--confirm:hover {
  background: #3dadd8;
  box-shadow: 0 4px 12px rgba(86, 189, 232, 0.3);
}


/* >>> dark companions: the light rules above pin these to a dark ink
   with !important, which on the dark field renders the text invisible
   rather than absent. Token references only. <<< */

.dark-mode .cn-input >>> .v-text-field__slot input,
.dark-mode .cn-input >>> .v-text-field__slot textarea {
  color: var(--app-text) !important;
}
</style>

<style>
/* Dialog container (unscoped) */
.cn-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
